// awsConfig.ts
import AWS from "aws-sdk";

// Configure AWS
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_ID,
  secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;
const s3 = new AWS.S3({
  signatureVersion: "v4",
});

export const downloadDocument = (key, fileName) => {
  const params = {
    Bucket: bucketName,
    Key: key,
  };

  s3.getObject(params, (err, data) => {
    if (err) {
      console.log(err, err.stack);
    } else {
      const base64Data = data.Body.toString("base64");
      const base64WithPrefix = `data:${data.ContentType};base64,${base64Data}`;
      const link = document.createElement("a");
      link.href = base64WithPrefix;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  });
};
